module.exports = __webpack_public_path__ + "img/144.61e805b8.jpg";